import IonMode from "./IonMode.js";
import AnalyticalMethod from "../../js/entities/AnalyticalMethod.js";
import {MeasuringModeName} from "./MeasuringModeName.js";

export default class DetectorMode {
    #analyticalMethod;
    /**@type {string} */
    #measuringMode;
    /** @type {IonMode} */
    #ionMode;

    /**
     * @param {AnalyticalMethod} analyticalMethod
     * @param {string} measuringMode
     * @param {IonMode} ionMode
     */
    constructor(analyticalMethod, measuringMode, ionMode) {
        this.#analyticalMethod = analyticalMethod;
        this.#measuringMode = measuringMode;
        this.#ionMode = ionMode;
    }

    /** @returns {AnalyticalMethod} */
    get analyticalMethod(){
        return this.#analyticalMethod
    }

    /** @returns {string} */
    get measuringMode(){
        return this.#measuringMode
    }

    /** @returns {IonMode} */
    get ionMode(){
        return this.#ionMode
    }

    /** @returns {boolean} */
    isProductIonScan(){
        return this.#measuringMode === MeasuringModeName.PRODUCT_SCAN
    }

    toServerJson(){
        return {
            analyticalMethod: this.#analyticalMethod.name,
            measuringMode: this.#measuringMode,
            ionMode: this.#ionMode.name
        }
    }

    /**
     * @param {DetectorMode} other
     * @returns {boolean}
     */
    equals(other){
        return this.#analyticalMethod.name === other.analyticalMethod.name &&
            this.#measuringMode === other.measuringMode &&
            this.#ionMode.name === other.ionMode.name;
    }

    /**
     * @param json
     * @returns {DetectorMode}
     */
    static parseJson(json){
        return new DetectorMode(AnalyticalMethod.fromString(json.analyticalMethod), json.measuringMode, new IonMode(json.ionMode))
    }
}